import {
  EmployeeExpectationsPayload,
  employeeExpectationsRequest,
} from "~/pages/Editor/EditorStaff/requests/employeeExpectationsRequest";

export async function updateEmployeeExpectations(
  data: EmployeeExpectationsPayload & { instanceId: number },
) {
  return employeeExpectationsRequest("PUT", data);
}
